// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/stylus/main.styl
// module id = 94Qc
// module chunks = 0